module.exports = __webpack_public_path__ + "img/rafias.5cd15d04.webp";